import React from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import Breadcrumb from '../../components/Breadcrumb'
import ConfigLayer from '../../components/ConfigPage/ConfigLayer'

const ConfigurationPage = () => {
  return (
   <MasterLayout>


    <Breadcrumb title={"Configuration"} />
    <ConfigLayer/>
    


   </MasterLayout>
  )
}

export default ConfigurationPage
